<!-- 课堂记录-->
<template>

    <el-row class="main-box">
				<el-col class="listdivcls" :offset="7" :span="10">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						课程记录</div>
					<div  class="itembgcls flex-row f-align-center" v-for="(itemdata, indexdata) in datalist" :key="indexdata" @click="startxx()">
						<div class="flex1" style="margin-left: 26px;text-align: start;"  @click="requsturl(itemdata.wordId)">{{itemdata.word}}</div>
						<div  class="flex1" style="text-align: end;height:80px;line-height: 80px;margin-right: 12px;"  @click="clic(indexdata)"> {{showind==indexdata?itemdata.chinese:''}}</div>
						<!-- <img v-if="userInfos.role==0" style="width: 56px;height: 56px;margin-right: 26px;" mode="fill"  @click="addcw(indexdata)"  :src="itemdata.isCollect==0?require('@/static/shouc_ic0.png'):require('@/static/shouc_ic1.png')"/> -->
						<img v-if="userInfos.role==0" style="width: 40px;height: 40px;margin-right: 26px;" mode="fill"  @click="addcw(indexdata)"  :src="itemdata.isCollect==0?require('@/static/shouc_ic0.png'):require('@/static/shouc_ic1.png')"/>
					</div>
				</el-col>
				
				<audio   ref="audio">
					<source :src="playsrc" type="audio/mp3"/>
				</audio>
    </el-row>
	

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Loading } from 'element-ui';
export default {
    data() {
        return {
			datalist:[
			],
			id:"",
			courseId:"",
			zqnum:0,
			cwnum:0,
			playsrc:"",
			isplay:false,
			showind:-1,
			}
    },
    computed: {
      ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
    },
	created() {
		this.id = decodeURIComponent(this.$route.query.id);
		this.courseId = decodeURIComponent(this.$route.query.courseId);
	    this.getdata();
	},
    methods: {
		startxx(){
			
		},
		clic(index){
			this.showind=index;
		},
		async requsturl(id){
			if(this.isplay)
			{
				return;
			}
			this.isplay=true;
			    let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		},
		play(url)
		{
				this.playsrc=url;
			let music1 = new Audio();
			 
			      music1 = url;
			 
			      this.$refs.audio.src = music1;
			 let audioPlayer = this.$refs.audio;
			 audioPlayer.playbackRate = 1.2;
		// 	      this.$refs.audio.play();
		
			this.$refs.audio.play();
		},
		async addcw(indexdata){
			// if(this.datalist[index].isGrasp==0)
			// {
			// 	return;
			// }
			var wordId=this.datalist[indexdata].wordId;
			var isCollect=this.datalist[indexdata].isCollect;
			
			var tisr="收藏成功";
			
			var url="/web/student/collect/add";
			if(isCollect==1)
			{
				url="/web/student/collect/remove";
				tisr="移除成功";
			}
				console.log("!!!!@@"+wordId+"!!!!!!!!!"+this.courseId);
				let res = await this.$api.post(url,{
					courseId:this.courseId,
					recordId:wordId,
				} ,{
				    headers: { //头部参数
				        frontUserToken: this.getUserToken
				    }
				});
				if(res.code==200)
				{
					if(isCollect==1)
					{
						this.datalist[indexdata].isCollect=0;
					}else{
						this.datalist[indexdata].isCollect=1;
					}
					this.$message({
					  type: "success",
					  message: ""+tisr,
					});
				}else{
				this.$message({
				  type: "warning",
				  message: res.msg
				})
				}
		},
		 finish(){
			this.$router.back();
		 },
		async getdata() {
		    let res = await this.$api.get("/web/teacher/home/classSalesRecordInfo", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					id:this.id ,
				 }
		    });
			if(res.code==200)
			{
				if(res.data==null||res.data.length<=0)
				{
					this.$message({
					  type: "warning",
					  message: "沒有课程记录！"
					});
						this.$router.back();
				}
				
				this.datalist=res.data;
			}
		},
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
	flex: 1;
    background: #B6E4D3;
    position: relative;
	padding-top: 84px;
	
	.listdivcls{
	  border-radius: 20px;
	  background: #E5F3F1;
	  padding-top: 21px;
	    padding-bottom: 21px;
	  font-family: Oswald;
	  font-size: 36px;
	  font-weight: normal;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 绿 */
	  color: #0AA26B;
	  
	  @media screen and (max-width: 1400px)  {
	   	  font-size: 26px;
	   }
	   
	   @media screen and (max-width: 1000px)  {
	    	  font-size: 20px;
	    }
	}
	
	
	.itembgcls{
		cursor: pointer;
		/* 矩形 55 */
		margin-left: 30px;
		margin-right: 30px;
		height: 80px;
		border-radius: 100px;
		opacity: 1;
		margin-top: 23px;
		/* 纯白 */
		background: #FFFFFF;
		box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
	}
	
	.xcls{
		height: 307px;
		border-radius: 20px;
		opacity: 1;
		background: #FFFFFF;
		
		
		.dccls{
			margin-left: 15px;
			margin-right: 15px;
			height: 76px;
			border-radius: 20px;
			opacity: 1;
			background: linear-gradient(330deg, #FFFFFF 14%, #D9F1E5 77%);
			box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
	
		}
		
		.text11{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 已选择 */
			font-family: 思源黑体;
			font-weight: 400;
			font-size: 18;
			color: #ACBEB0
		}
		
		.text12{
			font-family: Oswald;
			font-size: 36px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
		
		.text13{
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-family: Source Han Sans;
			font-weight: 400;
			font-size: 18px;
			color: #333333
		}
		
		
		.text14{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
		
		.text15{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 红 */
			color: #ED6565;
		}
		
		.bucls1{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			text-align: center;
			/* 绿 */
			background: #0AA26B;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: bold;
			line-height: 46px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 纯白 */
			color: #FFFFFF;
		}
		
		.bucls2{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			
			box-sizing: border-box;
			/* 绿 */
			border: 2px solid #0AA26B;
			text-align: center;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: normal;
			line-height: 46px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
	}
	
	.appraise-popup-title {
	    width: 100%;
	    height: 86px;
	    border-radius: 20px 20px 0 0;
	    background: #0AA26B;
	    box-sizing: border-box;
	    padding: 0 35px;
	
	    .appraise-popup-title-name {
	        font-family: 思源黑体;
	        font-size: 26px;
	        font-weight: bold;
	        line-height: normal;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 纯白 */
	        color: #FFFFFF;
	    }
	
	    img {
	        width: 56px;
	        height: 56px;
	    }
	}
	.start-popup-content {
	    background: #fff;
	    border-radius: 0 0 20px 20px;
	    box-sizing: border-box;
	    padding: 0 52px;
	
	    .start-popup-content-text1 {
	        margin-left: 173.5px;
	        margin-top: 89px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 333333 */
	        color: #333333;
	    }
	
	    .start-popup-content-timebox {
	        margin-top: 30px;
	        margin-left: 173.5px;
	
	        span {
	            margin-right: 30px;
	            font-family: 思源黑体;
	            font-size: 22px;
	            font-weight: normal;
	            line-height: 30px;
	            letter-spacing: 0em;
	
	            font-feature-settings: "kern" on;
	            /* 333333 */
	            color: #333333;
	        }
	
	        div {
	            width: 195px;
	            height: 64px;
	            border-radius: 100px;
	            opacity: 1;
	
	            background: #E5F7F1;
	
	            box-sizing: border-box;
	            border: 1px solid rgba(10, 162, 107, 0.2);
	        }
	
	    }
	
	    .start-popup-content-tipsbox {
	        margin-top: 89px;
	        margin-bottom: 75px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 确认开始学员 */
	        color: #333333
	    }
	
	    .start-popup-content-line {
	        margin-top: 30px;
	        width: 741.5px;
	        height: 0px;
	        opacity: 1;
	
	        border: 1px solid rgba(10, 162, 107, 0.2);
	    }
	
	    .start-popup-content-btnsbox {
	        margin-top: 31px;
	        margin-bottom: 30px;
	
	        div {
	            &:first-child {
	                margin-right: 20px;
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 灰 */
	                background: #ACBEB0;
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	
	            &:last-child {
	
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 绿 */
	                background: #0AA26B;
	
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	        }
	    }
	
	}
	
}



/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}
</style>